import { Show, ShowProps } from "react-admin";

export const StyledShow = ({ sx, ...props }: ShowProps) => {
  return (
    <Show
      {...props}
      actions={props.actions ?? false}
      component={props.component ?? "div"}
      sx={{
        "& .RaShow-main": {
          padding: 0,
          margin: 0,
        },
        "& .RaShow-card": {
          padding: 0,
          boxShadow: "none",
        },
        // Spread any additional sx passed in
        ...(sx || {}),
      }}
    />
  );
};
